const normalizeKey = (value?: string | null): string => (value || '').trim().toLowerCase();

export const isUnderpaidDisplayStatus = (displayStatus?: string | null): boolean =>
  normalizeKey(displayStatus).includes('underpaid');

export const isSuccessFinalStatus = (status?: string | null, displayStatus?: string | null): boolean => {
  const normalizedStatus = normalizeKey(status);
  const isFinalSuccess = normalizedStatus === 'completed' || normalizedStatus === 'payoutcompleted';
  if (!isFinalSuccess) {
    return false;
  }

  return !isUnderpaidDisplayStatus(displayStatus);
};

export const shouldShowMerchantReturnButton = (
  status?: string | null,
  displayStatus?: string | null,
  hasTrustedMerchantReturnUrl?: boolean | null
): boolean => isSuccessFinalStatus(status, displayStatus) && Boolean(hasTrustedMerchantReturnUrl);

